var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-progress-bar"},[_c('p',[_vm._v(_vm._s(_vm.formattedText))]),_c('span',{staticClass:"main-progress-bar__inner",style:({ width: `${this.backgroundWidthInPercentage}%` })})])
}
var staticRenderFns = []

export { render, staticRenderFns }